import { useRequestEvent, useState } from 'nuxt/app';
import type { InternalAxiosRequestConfig } from 'axios';
import { HEADER_X_AW_REQUEST_ID, HEADER_X_AW_TAB_ID } from '~~/common/config/TracingHeaders';

/**
 * Provides the request-tracing headers added to every BE/FE api XHR.
 */
export function useAwRequestTracing () {
  const feServerRequestId = useState('feServerRequestId', () => String(useRequestEvent()?.context?.feServerRequestId));

  const xhrEnv = import.meta.server ? 's' : 'c';
  let xhrRequestIdCounter = 0;

  return {
    getFeServerRequestId,
    setAwTracingHeaders,
  };

  function nextXhrRequestId () {
    return `${feServerRequestId.value}_${xhrEnv}_${++xhrRequestIdCounter}`;
  }

  /**
   * Attaches the tab id and a unique per-XHR request id to a BE/FE api request.
   */
  function setAwTracingHeaders (config: InternalAxiosRequestConfig) {
    config.headers[HEADER_X_AW_TAB_ID] = feServerRequestId.value;
    config.headers[HEADER_X_AW_REQUEST_ID] = nextXhrRequestId();
  }

  function getFeServerRequestId () {
    return feServerRequestId.value;
  }
}
